module.exports = __webpack_public_path__ + "img/person-orange.2e7cab3d.svg";